// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"90":"c2f15bad","673":"227ef4d9","800":"bd8cf927"}[chunkId] + ".chunk.css";
};